import Seo from '../components/Seo';

function TermsOfService() {
  return (
    <div className="legal-page">
      <Seo title="Terms of Service" description="QuickCalcs terms of service. Read the terms and conditions for using our free online calculators and tools." />
      <h1>Terms of Service</h1>
      <p className="legal-date">Last updated: February 24, 2025</p>

      <h2>Acceptance of Terms</h2>
      <p>By accessing and using QuickCalcs (quickcalcs.net), you agree to these Terms of Service. If you do not agree, please do not use our website.</p>

      <h2>Description of Service</h2>
      <p>QuickCalcs provides free online calculators, converters, generators, and utility tools. All tools run entirely in your browser — no account or sign-up is required.</p>

      <h2>Use of Tools</h2>
      <p>Our tools are provided for informational and educational purposes only. While we strive for accuracy, results should not be relied upon for professional, medical, financial, or legal decisions. Always verify important calculations with a qualified professional.</p>

      <h2>Accuracy Disclaimer</h2>
      <p>We make reasonable efforts to ensure our tools produce accurate results. However, we do not guarantee the accuracy, completeness, or reliability of any calculations or outputs. Use all results at your own risk.</p>

      <h2>Intellectual Property</h2>
      <p>All content on QuickCalcs, including text, design, and code, is owned by QuickCalcs and protected by applicable intellectual property laws. You may use our tools freely but may not copy, reproduce, or redistribute the website or its code.</p>

      <h2>Prohibited Uses</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the site in any way that violates applicable laws</li>
        <li>Attempt to interfere with or disrupt the website's operation</li>
        <li>Scrape, crawl, or use automated tools to access the site excessively</li>
        <li>Attempt to gain unauthorized access to our systems</li>
      </ul>

      <h2>Limitation of Liability</h2>
      <p>QuickCalcs is provided "as is" without warranties of any kind. To the fullest extent permitted by law, we shall not be liable for any damages arising from your use of the website or reliance on any tool results.</p>

      <h2>Third-Party Content</h2>
      <p>Our website displays advertisements from Google AdSense. We are not responsible for the content of these advertisements or any third-party websites they link to.</p>

      <h2>Changes to Terms</h2>
      <p>We reserve the right to modify these Terms of Service at any time. Continued use of the website after changes constitutes acceptance of the updated terms.</p>

      <h2>Governing Law</h2>
      <p>These terms are governed by and construed in accordance with applicable laws. Any disputes shall be resolved in the appropriate jurisdiction.</p>

      <h2>Contact Us</h2>
      <p>If you have questions about these Terms of Service, please contact us at support@quickcalcs.net.</p>
    </div>
  );
}

export default TermsOfService;
